import { IRoute } from "../../../common/helpers/routesMapper";
import { Store } from "redux";
import { seo } from "../../../common/helpers/seo";
import { IStateTree } from "../../store/interfaces";
import { getTeacher } from "../../store/teacher/actions";

import Teacher from "./lazy";

export default {
    component: Teacher,
    loadData: ({ dispatch }: { dispatch: any }, path: string) => dispatch(getTeacher(path)),
    renderSeo: ({ getState }: Store<IStateTree>, allMessage: {[key: string]: string}, lang: string) => {
        const { teacher } = getState();
        if (teacher!.notFound) {
            return seo({ title: allMessage["teacher.teacherNotFound"], allMessage, lang });
        }
        return seo({ title: teacher!.displayName || teacher!.username, type: "profile", allMessage, lang });
    },
} satisfies IRoute;
